<div class="dialog-container">
    <div class="dialog-title-block">
        <h2>Allocate Stores</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-3">
        <p class="text-para text-light-dark">
            The “<span class="text-capitalize">{{ dialogData.name }}</span>” users has not be allocated with any stores at the moment. Please allocate the stores from the 
            <a class="text-link text-primary text-decoration-underline cursor-pointer" (click)="redirectToUsers()">users</a> screen
        </p>
    </div>
    <div class="dialog-footer">
        <!-- <button type="button" (click)="onClose()">Cancel</button> -->
        <button type="submit" (click)="confirm()">Okay</button>
    </div>
</div>


